const cities = [
  { name: "Slidell", zips: "70458, 70460, 70461" },
  { name: "Pearl River", zips: "70452" },
  { name: "Lacombe", zips: "70445" },
  { name: "Eden Isle", zips: "70448" },
  { name: "Covington", zips: "70433, 70435" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required. Complete your order from home in Slidell, Pearl River, or Lacombe — without crossing the Causeway.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping from any Slidell-area UPS or FedEx. We handle every detail from there. No I-10 required.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed before submission — so North Shore families and commuters do not lose time to avoidable errors.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment or NOLA drive needed.",
  },
];

export default function SlidellLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Slidell &amp; the Northshore
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Slidell, Louisiana has become one of the fastest-growing communities in the greater New Orleans metro area. Situated on the northeast shore of Lake Pontchartrain, St. Tammany Parish and the surrounding Northshore communities offer a suburban lifestyle with easy Lake Pontchartrain Causeway access to downtown New Orleans. That access also means Slidell residents are within easy range of Louis Armstrong International Airport — and all the international travel that flows through it.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The Northshore commuter demographic is a distinctive passport market. Many Slidell residents work in New Orleans — in healthcare at Ochsner, Tulane, or University Medical Center; in energy at the many downtown oil and gas firms; in law, finance, and government. They earn the salaries that fund international business travel, European vacations, Caribbean cruises, and study-abroad programs for their children. But they have less time than anyone to navigate the New Orleans Passport Agency appointment system or make unnecessary trips downtown.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The cruise market is especially strong for Slidell. The Port of New Orleans is one of the busiest cruise departure points on the Gulf Coast, with year-round sailings to the Caribbean and Bahamas. Northshore families — from Pearl River to Lacombe to Eden Isle — book cruises through local travel agents and online, often with 2–4 week lead times. When they discover an expired passport in the family, the clock starts ticking immediately.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Southeastern Louisiana University students from the Northshore and beyond plan international programs and research trips that require expedited processing. Retired military families from NAS New Orleans area units who settled across the lake maintain active travel schedules. Fast Passport Center eliminates the need to fight Causeway traffic or I-10 congestion for a passport agency appointment — start online, ship from Slidell, and we handle the rest.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Slidell, LA</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving St. Tammany &amp; Washington Parishes</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — start online, ship overnight, we handle the rest
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">No Causeway traffic or New Orleans drive required</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  Start online, then <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx in Slidell or Covington. Most Northshore clients ship overnight — no trip downtown required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere on the Northshore — start online, ship overnight, and we handle the rest. No Causeway trip or downtown New Orleans appointment needed.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "New Orleans", href: "/cities/new-orleans" },
                    { name: "Baton Rouge", href: "/cities/baton-rouge" },
                    { name: "Hammond", href: "/states/louisiana" },
                    { name: "Mandeville", href: "/states/louisiana" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Northshore Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}